import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IFormValidationError} from '../../../class/FormValidation';

@Component({
    selector: 'noos-dialog-form-error',
    templateUrl: './dialog-form-error.component.html',
    styleUrls: ['./dialog-form-error.component.scss']
})
export class DialogFormErrorComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<DialogFormErrorComponent>,
                @Inject(MAT_DIALOG_DATA) public data: IFormValidationError[]) {
    }

    ngOnInit() {
    }

    onCancel() {
        this.dialogRef.close();
    }
}
